"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigNumFromString = void 0;
const superstruct_1 = require("superstruct");
const bignumber_js_1 = require("bignumber.js");
exports.BigNumFromString = (0, superstruct_1.coerce)((0, superstruct_1.instance)(bignumber_js_1.BigNumber), (0, superstruct_1.string)(), value => {
    if (typeof value === "string")
        return new bignumber_js_1.BigNumber(value, 10);
    throw new Error("invalid big num");
});
//# sourceMappingURL=bignum.js.map